import { makeSimpleId } from "../../../utils";

// --- TYPES ---

type Action = {
  type: string;
  payload: any;
};

export type StrCoords = {
  x: string;
  y: string;
  z: string;
};

type TableReducerState = {
  [x: string]: StrCoords;
};

// --- ACTIONS ---

export const ROW_UPDATED = "ROW_UPDATED";
export const updateRow = (id: string, coords: StrCoords) => ({
  type: ROW_UPDATED,
  payload: { id, coords },
});

// --- REDUCER ---

export default function tableReducer(
  state: TableReducerState = createInitialTableReducerState(3),
  action: Action,
): TableReducerState {
  switch (action.type) {
    case ROW_UPDATED:
      return {
        ...state,
        [action.payload.id]: action.payload.coords,
      };
    default:
      return state;
  }
}

// --- GETTERS ---

export const getRowsNumber = (rows: TableReducerState) =>
  Object.keys(rows).length;

// --- UTILS ---

export const createEmptyRow = () => ({
  x: "",
  y: "",
  z: "",
});

export const createInitialTableReducerState = (
  numRows: number,
): TableReducerState =>
  [...Array(numRows)].reduce(
    acc => ({
      ...acc,
      [makeSimpleId()]: createEmptyRow(),
    }),
    {},
  );
